<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CHsX2J/tc-custom/9780813166957.jpg?1703389915977" alt="This image is the cover for the book My Brother Slaves"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Brother Slaves
      </h1>
      <p class="bookDescription body article font2">
        <p>Trapped in a world of brutal physical punishment and unremitting, back-breaking labor, Frederick Douglass mused that it was the friendships he shared with other enslaved men that carried him through his darkest days.  In this pioneering study, Sergio A. L</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sergio Lussana
      </h2>
      
      <p class="authorDescription body article">Sergio A. Lussana is senior lecturer of history at Nottingham Trent University and is coeditor of Black and White Masculinity in the American South, 1800–2000.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University Press of Kentucky
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2f6958d5